import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowRight } from 'lucide-react';
import { LogoFull } from '../components/Logo';
import api, { setToken } from '../lib/api';

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState(null);
  const [form, setForm] = useState({ nombre: '', apellido: '', password: '' });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/invite/${token}`);
        setInvite(data);
      } catch (e) {
        setError(e?.response?.data?.detail || 'Invitación inválida.');
      }
    })();
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post('/invite/accept', { token, ...form });
      setToken(data.token);
      toast.success(`Bienvenido a ${data.organization.razon_social}`);
      navigate('/app/dashboard');
      window.location.reload();
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'No pudimos completar el registro');
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-[#F7F8FA] flex flex-col">
      <div className="p-6"><LogoFull height={30} /></div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="bg-white border border-[#E5E7EB] max-w-md w-full p-8">
          {error ? (
            <>
              <h1 className="text-xl font-semibold text-[#1C2329]">Invitación no válida</h1>
              <p className="mt-2 text-sm text-[#6B7280]">{error}</p>
              <button className="mt-6 pv-btn-primary" onClick={() => navigate('/login')}>Ir a inicio</button>
            </>
          ) : !invite ? (
            <div className="text-sm text-[#6B7280]">Verificando invitación…</div>
          ) : (
            <form onSubmit={submit} data-testid="accept-form">
              <div className="pv-eyebrow mb-2">Invitación</div>
              <h1 className="text-2xl font-semibold text-[#1C2329]">Únase a <span className="text-[#143A34]">{invite.organization}</span> en Priviax</h1>
              <p className="mt-2 text-sm text-[#6B7280]">Correo: <b>{invite.email}</b> · Rol: <b>{invite.role.replace('_', ' ')}</b></p>
              <div className="mt-6 space-y-4">
                <div>
                  <label className="block text-[12px] font-medium text-[#374151] mb-1.5 uppercase tracking-wider">Nombre</label>
                  <input required className="pv-input" value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} data-testid="ai-nombre" />
                </div>
                <div>
                  <label className="block text-[12px] font-medium text-[#374151] mb-1.5 uppercase tracking-wider">Apellido</label>
                  <input required className="pv-input" value={form.apellido} onChange={(e) => setForm({ ...form, apellido: e.target.value })} data-testid="ai-apellido" />
                </div>
                <div>
                  <label className="block text-[12px] font-medium text-[#374151] mb-1.5 uppercase tracking-wider">Contraseña</label>
                  <input required type="password" minLength={8} className="pv-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="ai-password" />
                </div>
              </div>
              <button type="submit" disabled={submitting} className="mt-6 pv-btn-primary w-full flex items-center justify-center gap-2" data-testid="ai-submit">
                {submitting ? 'Creando cuenta…' : 'Aceptar invitación e ingresar'}<ArrowRight size={15} />
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
